// extracted by mini-css-extract-plugin
export var details = "_ex-0";
export var inspectorPopover = "_ex-1";